const TEST_XML_TEMPLATE: string = `<test>
	<!-- Replace the "view" with an existing one. -->
	<view extends="" />
	<steps>
		<!-- Define your test steps here. -->
	</steps>
</test>
`;

export default TEST_XML_TEMPLATE;
